<template>
  <div class="settings-view">
    <div class="menu-settings">
      <strong>Общие настройки по проекту</strong>
      <div class="edit-ul">
        <div class="edit-li">
          <router-link to="/dashboard/users" class="link-cont">
            <span>
              Пользователи
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>
        <div class="edit-li">
          <div class="help-container">
            <el-popover
              placement="top-start"
              title=""
              width="200"
              trigger="click"
              content="Проекты могут включать несколько объектов. Это могут быть: секции, этажи, блоки, титулы, или разделы рабочей документации (КМ, КЖ и т.д.). Можно задать любую иерархию объектов и привязать свой перечень работ к каждому объекту, нажав (символ «колесико»).">
              <i slot="reference" class="el-icon-question"/>
            </el-popover>
          </div>
          <router-link to="/dashboard/objects" class="link-cont">
            <span>
              Объекты
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>
        <div class="edit-li">
          <div class="help-container">
            <el-popover
              placement="top-start"
              title=""
              width="200"
              trigger="click"
              content="Создайте «Виды работ» и привяжите их при создании работы в разделе «Работы». Это объединит однотипные работы в единую категорию и позволит получать Аналитику план-факт по видам работ в «Сводке по видам работ». ">
              <i slot="reference" class="el-icon-question"/>
            </el-popover>
          </div>
          <router-link to="/dashboard/works/list" class="link-cont">
            <span>
              Виды работ
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <div class="edit-li">
          <div class="help-container">
            <el-popover
              placement="top-start"
              title=""
              width="200"
              trigger="click"
              content="Разделы работ">
              <i slot="reference" class="el-icon-question"/>
            </el-popover>
          </div>
          <router-link to="/dashboard/dirs" class="link-cont">
            <span>
              Разделы работ
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <div class="edit-li">
          <div class="help-container">
            <el-popover
              placement="top-start"
              title=""
              width="200"
              trigger="click"
              content="Создайте работы с указанием ед. измерения, плана и вида работ (если необходимо) или загрузите работы из Excel. Если вы используете объекты, удобно создавать или загружать работы прямо из справочника «Объекты», нажав (символ колесико) напротив соответствующего объекта.">
              <i slot="reference" class="el-icon-question"/>
            </el-popover>
          </div>
          <router-link to="/dashboard/jobs" class="link-cont">
            <span>
              Работы
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <div class="edit-li">
          <div class="help-container">
            <el-popover
              placement="top-start"
              title=""
              width="200"
              trigger="click"
              content="Создайте перечень профессии для отчетов по численности. Кроме количественного учета можно добавить учет по часам, поставив галочку «Учет по часам».">
              <i slot="reference" class="el-icon-question"/>
            </el-popover>
          </div>
          <router-link to="/dashboard/prof" class="link-cont">
            <span>
              Профессии
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <div class="edit-li">
          <div class="help-container">
            <el-popover
              placement="top-start"
              title=""
              width="200"
              trigger="click"
              content="Создайте перечень техники, механизмов или оборудования для отчетов по технике. Кроме количественного учета можно добавить учет по часам, поставив галочку «Учет по часам».">
              <i slot="reference" class="el-icon-question"/>
            </el-popover>
          </div>
          <router-link to="/dashboard/tech" class="link-cont">
            <span>
              Техника
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <div class="edit-li">
          <router-link to="/dashboard/documentation/edit" class="link-cont">
            <span>
              Документация
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <div class="edit-li" v-if="this.$store.state.project.tasks">
          <router-link to="/dashboard/tasks/categories" class="link-cont">
            <span>
              Категории задач
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <router-link
          :to="`/dashboard/unit`"
          class="edit-li"
        >
          Единицы измерения <i class="fas fa-chevron-right"></i>
        </router-link>

        <router-link
          :to="`/dashboard/versions`"
          class="edit-li"
        >
          Настройка планов <i class="fas fa-chevron-right"></i>
        </router-link>

        <router-link
          :to="`/dashboard/workorders`"
          class="edit-li"
        >
          Настройка нарядов <i class="fas fa-chevron-right"></i>
        </router-link>
        <router-link
          v-if="form.daily_plan"
          :to="`/dashboard/plan`"
          class="edit-li"
        >
          Месячно-суточный план <i class="fas fa-chevron-right"></i>
        </router-link>
        <router-link
          v-if="available_reports.ONE_REPORT"
          :to="`/dashboard/report-one-settings`"
          class="edit-li"
        >
          Настройка единого отчета <i class="fas fa-chevron-right"></i>
        </router-link>
      </div>
      <div v-if="role === 'admin'" style="width: 100%; display: flex; align-items: flex-start; flex-direction: column">
        <strong>Доступные общие отчеты</strong>
        <div class="edit-ul checkbox-ul">
          <div
            class="edit-li"
          >
            Единый отчет
            <el-checkbox @change="save" v-model="available_reports.ONE_REPORT"></el-checkbox>
          </div>
          <div
            class="edit-li"
          >
            Отчеты по работам
            <el-checkbox @change="save" v-model="available_reports.JOB"></el-checkbox>
          </div>
          <div
            class="edit-li"
          >
            Отчеты по технике
            <el-checkbox @change="save" v-model="available_reports.TECH"></el-checkbox>
          </div>
          <div
            class="edit-li"
          >
            Отчеты по численности
            <el-checkbox @change="save" v-model="available_reports.PROF"></el-checkbox>
          </div>

          <div
            class="edit-li"
          >
            Табель
            <el-checkbox @change="save" v-model="available_reports.TABEL"></el-checkbox>
          </div>

          <div
            class="edit-li"
          >
            Наряд
            <el-checkbox @change="save" v-model="form.workorder"></el-checkbox>
          </div>
        </div>
      </div>

      <div v-if="role === 'admin'" style="width: 100%; display: flex; align-items: flex-start; flex-direction: column">
        <strong>Общие настройки</strong>
        <div class="edit-ul checkbox-ul">
          <div class="edit-li">
            Задачи
            <el-checkbox @change="save" v-model="form.tasks"></el-checkbox>
          </div>
          <div
            class="edit-li"
          >
            Учет сроков
            <el-checkbox @change="save" v-model="form.deadline_accounting"></el-checkbox>
          </div>
          <div
            class="edit-li"
          >
            Учет трудоемкости
            <el-checkbox @change="save" v-model="form.progress"></el-checkbox>
          </div>
          <div
            class="edit-li"
            style="flex-direction: column; height: auto; padding-top: 8px; padding-bottom: 8px; align-items: flex-start"
          >
            <div style="display: flex; justify-content: space-between; margin-bottom: 8px; width: 100%">
              Учет стоимости или второй ед. измерения
              <el-checkbox @change="save" v-model="form.price"></el-checkbox>
            </div>
            <el-input @change="save" :maxlength="9" style="max-width: 200px" v-model="form.unit_name" placeholder/>

          </div>
          <div class="edit-li">
            Месячно-суточный план
            <el-checkbox @change="save" v-model="form.daily_plan"></el-checkbox>
          </div>
          <div class="edit-li">
            Погода
            <el-checkbox @change="save" v-model="form.weather"></el-checkbox>
          </div>
          <div class="edit-li">
            Показывать стоимость исполнителям
            <el-checkbox @change="save" :value="!form.price_ignore"
                         @input="(e) => form.price_ignore = !e"></el-checkbox>
          </div>

          <div class="edit-li">
            Отчеты по численности
            <el-checkbox @change="save" :value="!form.work_type_ignore" @input="(e) => form.work_type_ignore = !e">По
              видам работ
            </el-checkbox>
            <el-checkbox @change="save" v-model="form.work_dir">По разделам работ</el-checkbox>

          </div>
          <div class="edit-li">
            Обязательный вид работ по численности
            <el-checkbox @change="save" v-model="form.work_type_require"></el-checkbox>
          </div>

          <div class="edit-li">
            Вывод объектов по иерархии
            <el-checkbox @change="save" v-model="form.object_list"></el-checkbox>
          </div>

          <div class="edit-li">
            Поиск по работам из объектов
            <el-checkbox @change="save" v-model="form.object_job_search"></el-checkbox>
          </div>

          <!--          <div class="edit-li">-->
          <!--            Единый отчет-->
          <!--            <el-checkbox @change="save" v-model="form.single_report"></el-checkbox>-->
          <!--          </div>-->
        </div>
      </div>
      <div class="edit-ul edit-ul-next">
        <router-link
          :to="`/dashboard/work_section`"
          class="edit-li"
        >
          <strong>
            Настройки по разделам работ</strong> <i class="fas fa-chevron-right"></i>
        </router-link>

        <router-link
          :to="`/dashboard/inputs`"
          class="edit-li"
        >
          <strong>
            Настройки полей</strong> <i class="fas fa-chevron-right"></i>
        </router-link>

        <div class="edit-li count" @click="replaceReportHandler" v-loading="loading">
          <strong>
            Замена в отчетах
          </strong>
        </div>

        <div class="edit-li count" @click="resetCount" v-loading="loading">
          <strong>
            Обновить счетчики
          </strong>
        </div>
      </div>
    </div>
    <el-form class="settings-form" v-if="role === 'admin'">
      <el-form-item label="Название проекта">
        <el-input v-model="form.name" placeholder/>
      </el-form-item>
      <el-form-item label="Адрес проекта">
        <el-input v-model="form.address"/>
      </el-form-item>
      <el-form-item label="Описание проекта">
        <el-input v-model="form.description" type="textarea" textarea/>
      </el-form-item>
      <el-form-item label="Код проекта">
        <el-input v-model="form.code"/>
      </el-form-item>
      <div>
        <el-form-item label="Директивный срок начала проекта">
          <div style="margin-left: -70px">
            <el-date-picker
              :editable="false"
              @input="changeDate"
              format="yyyy-MM-dd"
              v-model="form.start_date"
              type="date"
              placeholder="Укажите дату"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="Директивный срок окончания проекта">
          <div style="margin-left: -70px">
            <el-date-picker
              @input="changeDate"
              :editable="false"
              format="yyyy-MM-dd"
              v-model="form.end_date"
              type="date"
              placeholder="Укажите дату"
            >
            </el-date-picker>
          </div>
        </el-form-item>


        <div class="telegram-container">
          <div class="telegram-label">
            <img src="@/assets/icon/tg.svg">
            Telegram
          </div>
          <el-input style="max-width: 200px" v-model="form.telegramChatIds" placeholder/>
        </div>
      </div>
      <div class="footer-edit">
        <el-button @click="save" type="primary">Сохранить</el-button>
      </div>


      <div class="delete-project">
        <el-button type="danger" plain @click="deleteProject">Удалить проект</el-button>
      </div>
    </el-form>

    <ReplaceReport ref="replaceReport"/>
  </div>
</template>

<script>
import firebase from 'firebase';
import dayjs from "dayjs";
import axios from "axios";
import {apiUrl} from "../../../plugins/firebase";
import ReplaceReport from "./components/ReplaceReport";

export default {
  name: 'SettingsView',
  components: {ReplaceReport},
  data() {
    return {
      loading: false,
      form: {
        start_date: null,
        end_date: null,
        name: '',
        telegramChatIds: '',
        address: '',
        description: '',
        object_list: false,

        directive: false,
        progress: false,
        deadline_accounting: false,
        daily_plan: false,
        price: false,
        tasks: false,
        code: '',
        object_job_search: false,
        unit_name: '',
        weather: false,
        price_ignore: false,
        work_type_ignore: false,
        work_dir: false,
        workorder: false,
        single_report: false,
        work_type_require: false
      },
      role: 'admin',
      available_reports: {
        ONE_REPORT: false,
        JOB: true,
        TECH: true,
        PROF: true,
        COVID: true,
        TABEL: false,
      },
    };
  },

  mounted() {
    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id).get().then((sub) => {
      const data = sub.data();
      if (data) {
        const rules = data.rules;
        if (rules) {
          this.role = rules[ authFirestore.currentUser.uid];

          if (data.isDemo) {
            this.role = 'admin';
          }
          this.loading = false;
        }
      }
    });
    const {
      name,
      address,
      start_date,
      price_ignore,
      end_date,
      object_list,
      unit_name,
      weather,
      code,
      telegramChatIds,
      work_dir,
      work_type_ignore,
      description,
      tasks,
      object_job_search,
      progress,
      single_report,
      workorder,
      deadline_accounting,
      available_reports,
      daily_plan,
      work_type_require,
      price,
      directive
    } = this.$store.state.project;

    this.form = {
      start_date: dayjs(start_date).format('YYYY') === '1970' ? null : start_date,
      end_date: dayjs(end_date).format('YYYY') === '1970' ? null : end_date,
      name, address, description,
      code: code || '',
      telegramChatIds: telegramChatIds || '',
      progress: progress || false,
      daily_plan: daily_plan || false,
      price: price || false,
      single_report: single_report || false,
      tasks: tasks || false,
      object_list: object_list || false,
      object_job_search: object_job_search || false,
      work_type_require: work_type_require || false,
      workorder: workorder || false,
      directive: directive || false,
      weather: weather || false,
      work_dir: work_dir || false,
      unit_name: unit_name || null,
      work_type_ignore: work_type_ignore || false,
      price_ignore: price_ignore || false,
      deadline_accounting: deadline_accounting || false,
    };

    if (this.available_reports) {
      this.available_reports = {
        ...this.available_reports,
        ...available_reports,
      };
    }
  },

  methods: {
    replaceReportHandler() {
      this.$refs.replaceReport.open()
    },
    async resetCount() {
      this.loading = true
      let url = `onUpdateTotalValuesByReport/${this.$store.state.project.id}`

      await axios.get(apiUrl + '/' + url)

      this.loading = false
      this.$notify.success({
        offset: 60,
        title: 'Счетчики обновлены',
      });
    },
    changeDate() {
      if (this.form.start_date && this.form.end_date) {
        const s = '' + this.form.start_date;
        const e = '' + this.form.end_date;

        const start = dayjs(s).unix();
        const end = dayjs(e).unix();

        if (start && end && start > end) {
          this.form.start_date = null;
          this.$notify.error({title: 'Ошибка', message: 'Дата начала должна быть не позднее даты окончания'});
        }
      }
    },
    deleteProject() {
      this.$confirm(`Вы действительно хотите удалить проект?`,
        `При удалении проекта вся информация будет удалена без возможности востановления`, {
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
          type: 'warning',
        }).then(async () => {
        if (this.form.name !== 'Демонстрационный проект') {
          myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .delete()
            .then((data) => {
              localStorage.removeItem('projectId');
              window.location.href = '/';
            });
        } else {
          await myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .update({
              isDelete: true
            })

          localStorage.removeItem('projectId');
          window.location.href = '/';
        }
      });
    },
    save() {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .update({
          ...this.form,
          code: this.form.code || '',
          start_date: this.form.start_date ? dayjs(this.form.start_date).format('YYYY-MM-DD') : null,
          end_date: this.form.end_date ? dayjs(this.form.end_date).format('YYYY-MM-DD') : null,
          available_reports: this.available_reports,
        }).then(() => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Сохранено',
          type: 'success',
        });
        this.$store.dispatch('setProject', {
          ...this.form,
          code: this.form.code || '',
          start_date: this.form.start_date ? dayjs(this.form.start_date).format('YYYY-MM-DD') : null,
          end_date: this.form.end_date ? dayjs(this.form.end_date).format('YYYY-MM-DD') : null,
          available_reports: this.available_reports,
          id: this.$store.state.project.id,
        });
      })
        .catch((error) => console.error(error));
    }
    ,
  },
}
;
</script>

<style scoped lang="scss">
.settings-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
  max-width: 600px;
  margin: 0 auto;
  padding-bottom: 40px;

  .settings-form {
    max-width: 600px;
    width: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .el-form-item {
      width: 100%;
    }
  }

  .footer-edit {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
  }
}

.edit-li {
  display: flex;
  justify-content: space-between;
  height: 40px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  cursor: pointer;
  align-items: center;
  padding: 0 10px;
  text-decoration: none;
  color: #000;

  span:first-child {
    margin-right: 20px;
  }

  span {
    margin-right: 5px;
  }

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f5f5f5;
  }
}

.checkbox-ul {
  .edit-li {
    &:hover {
      background: #fff
    }
  }
}

.edit-ul {
  width: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 40px;
}

.menu-settings {
  display: flex;
  align-items: flex-start;
  width: calc(100% - 40px);
  flex-direction: column;
  margin-bottom: 40px;
}

.edit-ul-next {
  margin-top: 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  border-top: 1px solid rgba(0, 0, 0, 0.18);
}

.delete-project {
  margin-top: 80px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.section-li {
  display: flex;
}

.link-cont {
  display: flex;
  justify-content: space-between;
  color: #000;
  text-decoration: none;
  flex: 1;
}

.help-container {
  width: 32px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-li.count {
  display: flex;
  justify-content: center;
}

.telegram-label {
  display: flex;
  align-items: center;
  font-weight: bold;
  margin-bottom: 8px;

  img {
    width: 26px;
    margin-right: 12px;
  }
}

.telegram-container {
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
</style>
<style>
.el-popover {
  text-align: unset !important;
  word-break: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Projects/Edit.vue